import React from 'react';

const Footer = () => {
  return (
    <footer className="py-[6rem] px-0 pb-[4rem] bg-white text-center border-t border-border-light">
      <div className="container mx-auto px-8">
        <img 
          src="/logo.jpeg" 
          alt="BASCO Distribution" 
          className="h-[50px] w-auto object-contain mx-auto mb-[1.5rem]" 
        />
        <p className="text-[0.95rem] font-medium text-text-muted mb-4">Wholesale Distribution • Global Sourcing</p>
        <p className="text-[0.85rem] text-text-muted mb-[3rem]">Trusted by partners since 2006.</p>
        <div className="text-[0.8rem] text-text-muted pt-8 border-t border-border-light max-w-[400px] mx-auto">
          &copy; {new Date().getFullYear()} BASCO Distribution. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
